/* Ontwerpstudio PV-stickers 35 x 60 mm voor ricardwebshop.nl.

   De canvas-tekenroute spiegelt de druk: dezelfde opbouw en dezelfde maten als
   herteken.py en drukvel.jsx. Wijzigt daar iets, dan hier ook.

   Opbouw van onder naar boven: wit vlak, rood over de pictogramzone, wit
   binnenvlak, de binneninhoud (PNG uit het bronbestand), het logo, de teksten.
   De preview toont de sticker op eindformaat met afgeronde hoeken; de afloop
   zit alleen in het drukbestand. */
(function () {
  "use strict";

  var GEO = window.PVSTUDIO_GEO;
  var ASSETS = window.PVSTUDIO_ASSETS || {};
  var VARIANTEN = window.PVSTUDIO_VARIANTEN || [];
  var canvas = document.getElementById("pv-canvas");
  if (!GEO || !canvas) { return; }

  var ctx = canvas.getContext("2d");
  var STICKER_MM = GEO.sticker.netto_mm;      // [35, 60]
  var RADIUS_MM = GEO.sticker.radius_mm;
  var SPELING_MM = GEO.sticker.speling_mm;
  var MARGE_MM = 5;                            // witruimte rondom in de preview

  // De tekenruimte in logische pixels (de maat uit het canvas-attribuut). Op
  // een retinascherm staan er twee echte pixels op elke logische, maar alle
  // coordinaten hier blijven logisch; hiDPI() zet daar de schaal voor.
  var LOGISCH_B = canvas.width;
  var LOGISCH_H = canvas.height;
  var DPR = 1;
  var PX_PER_MM = LOGISCH_B / (STICKER_MM[0] + 2 * MARGE_MM);
  var TEKST = GEO.tekst;
  var PT_NAAR_MM = 25.4 / 72;

  var VOLGORDE = GEO.volgorde || Object.keys(GEO.pictogrammen);
  var START = window.PVSTUDIO_START;
  if (VOLGORDE.indexOf(START) < 0) { START = VOLGORDE[0]; }

  var state = {
    pictogram: START,
    pictogramY: 1,                             // 0 = bovenaan, 1 = onderaan
    teksten: [
      { tekst: "", x: 0.70, y: 0.048, schaal: 0.7, kleur: TEKST.standaard_kleur },
      { tekst: "", x: 0.70, y: 0.112, schaal: 0.7, kleur: TEKST.standaard_kleur },
      { tekst: "", x: 0.50, y: 0.945, schaal: 0.7, kleur: TEKST.standaard_kleur }
    ],
    logoUrl: "",
    logoBeeld: null,
    logo: { x: 0.27, y: 0.08, breedte: 0.34 },
    variantId: VARIANTEN.length ? VARIANTEN[0].id : null,
    snapshotUrl: "",
    bezig: false
  };

  var pictogramBeelden = {};
  var sleep = null;

  /* ---------- hulpjes ---------- */

  function mmx(v) { return v * PX_PER_MM; }
  function klem(v, laag, hoog) { return Math.max(laag, Math.min(hoog, v)); }

  function laadBeeld(url, klaar) {
    var img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = function () { klaar(img); };
    img.onerror = function () { klaar(null); };
    img.src = url;
  }

  function pictogramBeeld(sleutel, klaar) {
    if (pictogramBeelden[sleutel]) { klaar(pictogramBeelden[sleutel]); return; }
    var url = (ASSETS.pictogrammen || {})[sleutel];
    if (!url) { klaar(null); return; }
    laadBeeld(url, function (img) {
      if (img) { pictogramBeelden[sleutel] = img; }
      klaar(img);
    });
  }

  function afgerondPad(t, x, y, b, h, r) {
    t.beginPath();
    t.moveTo(x + r, y);
    t.lineTo(x + b - r, y);
    t.quadraticCurveTo(x + b, y, x + b, y + r);
    t.lineTo(x + b, y + h - r);
    t.quadraticCurveTo(x + b, y + h, x + b - r, y + h);
    t.lineTo(x + r, y + h);
    t.quadraticCurveTo(x, y + h, x, y + h - r);
    t.lineTo(x, y + r);
    t.quadraticCurveTo(x, y, x + r, y);
    t.closePath();
  }

  /** Bovenkant en onderkant van de pictogramzone in mm vanaf de snijlijn. */
  function zoneMm() {
    var pic = GEO.pictogrammen[state.pictogram];
    var boven = klem(state.pictogramY, 0, 1) * SPELING_MM;
    return { boven: boven, onder: boven + pic.netto_mm[1] };
  }

  function fontPx(schaal) {
    return mmx(TEKST.basis_pt * PT_NAAR_MM * schaal);
  }

  /** Korps in px, verkleind als de regel anders over de rand van de sticker
      loopt. Zelfde regel als passende_korps() in herteken.py, zodat de
      preview laat zien wat er gedrukt wordt. */
  function passendFontPx(t, inhoud, schaal) {
    var px = fontPx(schaal);
    if (!inhoud) { return px; }
    var ruimte = mmx(STICKER_MM[0] - 2 * (TEKST.marge_mm || 1));
    t.font = TEKST.gewicht + " " + px.toFixed(2) + "px " + TEKST.font_stapel;
    var breed = t.measureText(inhoud).width;
    if (breed <= ruimte || breed <= 0) { return px; }
    // niet onder de bodem: kleiner dan 6 pt drukt de machine niet netjes
    var bodem = mmx((TEKST.bodem_pt || 6) * PT_NAAR_MM);
    return Math.max(bodem, px * ruimte / breed);
  }

  /** Past deze regel zelfs op de bodemmaat nog op de sticker? */
  function pastOpDeSticker(inhoud) {
    if (!inhoud) { return true; }
    var bodem = mmx((TEKST.bodem_pt || 6) * PT_NAAR_MM);
    ctx.font = TEKST.gewicht + " " + bodem.toFixed(2) + "px " + TEKST.font_stapel;
    return ctx.measureText(inhoud).width
           <= mmx(STICKER_MM[0] - 2 * (TEKST.marge_mm || 1));
  }

  function bijwerkenTekstmeldingen() {
    state.teksten.forEach(function (tekst, i) {
      var el = document.getElementById("pv-tekst-" + (i + 1) + "-melding");
      if (!el) { return; }
      var teLang = !pastOpDeSticker((tekst.tekst || "").trim());
      el.hidden = !teLang;
      if (teLang) {
        el.textContent = "Deze regel is te lang voor de sticker. Kort hem in, "
          + "anders drukken we hem kleiner dan goed leesbaar is.";
      }
    });
  }

  function zetFont(t, schaal, inhoud) {
    var px = passendFontPx(t, inhoud || "", schaal);
    t.font = TEKST.gewicht + " " + px.toFixed(2) + "px " + TEKST.font_stapel;
    return px;
  }

  /* ---------- tekenen ---------- */

  function tekenOp(t, offsetMm) {
    var dx = mmx(offsetMm), dy = mmx(offsetMm);
    var breedte = mmx(STICKER_MM[0]), hoogte = mmx(STICKER_MM[1]);
    var pic = GEO.pictogrammen[state.pictogram];
    var rand = pic.rand.breedte_mm;
    var zone = zoneMm();

    t.save();
    afgerondPad(t, dx, dy, breedte, hoogte, mmx(RADIUS_MM));
    t.clip();

    // wit vlak
    t.fillStyle = "#ffffff";
    t.fillRect(dx, dy, breedte, hoogte);

    // rood over de pictogramzone
    t.fillStyle = pic.rand.kleur;
    t.fillRect(dx, dy + mmx(zone.boven), breedte, mmx(zone.onder - zone.boven));

    // wit binnenvlak
    t.fillStyle = pic.binnenvlak_kleur;
    t.fillRect(dx + mmx(rand), dy + mmx(zone.boven + rand),
               breedte - mmx(2 * rand), mmx(zone.onder - zone.boven - 2 * rand));

    // de binneninhoud uit het bronbestand
    var beeld = pictogramBeelden[state.pictogram];
    if (beeld) {
      t.drawImage(beeld, dx + mmx(rand), dy + mmx(zone.boven + rand),
                  breedte - mmx(2 * rand),
                  mmx(zone.onder - zone.boven - 2 * rand));
    }

    // het logo
    if (state.logoBeeld) {
      var r = logoRechthoek();
      t.drawImage(state.logoBeeld, dx + r.x, dy + r.y, r.b, r.h);
    }

    // de teksten
    t.textBaseline = "alphabetic";
    state.teksten.forEach(function (tekst) {
      var inhoud = (tekst.tekst || "").trim();
      if (!inhoud) { return; }
      var px = zetFont(t, tekst.schaal, inhoud);
      t.fillStyle = tekst.kleur;
      var b = t.measureText(inhoud).width;
      t.fillText(inhoud, dx + tekst.x * breedte - b / 2,
                 dy + tekst.y * hoogte + px * 0.35);
    });

    t.restore();

    // dunne grijze snijrand zodat de klant ziet waar de sticker ophoudt
    t.save();
    afgerondPad(t, dx, dy, breedte, hoogte, mmx(RADIUS_MM));
    t.strokeStyle = "rgba(0,0,0,0.18)";
    t.lineWidth = 1;
    t.stroke();
    t.restore();
  }

  function teken() {
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
    ctx.fillStyle = "#f6f6f6";
    ctx.fillRect(0, 0, LOGISCH_B, LOGISCH_H);
    tekenOp(ctx, MARGE_MM);
  }

  /* ---------- posities en slepen ---------- */

  function logoRechthoek() {
    if (!state.logoBeeld) { return null; }
    var breedte = mmx(STICKER_MM[0]), hoogte = mmx(STICKER_MM[1]);
    var b = klem(state.logo.breedte, GEO.logo.breedte_min, GEO.logo.breedte_max) * breedte;
    var h = b * (state.logoBeeld.naturalHeight / state.logoBeeld.naturalWidth);
    return { x: state.logo.x * breedte - b / 2, y: state.logo.y * hoogte - h / 2, b: b, h: h };
  }

  function tekstRechthoek(tekst) {
    var inhoud = (tekst.tekst || "").trim();
    if (!inhoud) { return null; }
    var breedte = mmx(STICKER_MM[0]), hoogte = mmx(STICKER_MM[1]);
    var h = zetFont(ctx, tekst.schaal, inhoud);
    var b = ctx.measureText(inhoud).width;
    return { x: tekst.x * breedte - b / 2, y: tekst.y * hoogte - h / 2, b: b, h: h };
  }

  function punt(evt) {
    var vak = canvas.getBoundingClientRect();
    // van schermpixels naar de logische tekenruimte. Niet canvas.width
    // gebruiken: die telt de ECHTE pixels, en op een retinascherm zijn dat er
    // twee keer zoveel. Dan wees elke muisklik naar de verkeerde plek en pakte
    // het slepen niets (gevonden 2026-08-26).
    var schaal = LOGISCH_B / vak.width;
    return {
      x: (evt.clientX - vak.left) * schaal - mmx(MARGE_MM),
      y: (evt.clientY - vak.top) * schaal - mmx(MARGE_MM)
    };
  }

  function inRechthoek(p, r, speling) {
    if (!r) { return false; }
    speling = speling || 4;
    return p.x >= r.x - speling && p.x <= r.x + r.b + speling &&
           p.y >= r.y - speling && p.y <= r.y + r.h + speling;
  }

  function pakOp(p) {
    // van boven naar beneden in tekenvolgorde: eerst de teksten, dan het logo,
    // dan het pictogram (dat schuift alleen verticaal).
    for (var i = state.teksten.length - 1; i >= 0; i--) {
      if (inRechthoek(p, tekstRechthoek(state.teksten[i]))) {
        return { soort: "tekst", index: i };
      }
    }
    if (inRechthoek(p, logoRechthoek())) { return { soort: "logo" }; }
    var zone = zoneMm();
    if (p.y >= mmx(zone.boven) && p.y <= mmx(zone.onder) &&
        p.x >= 0 && p.x <= mmx(STICKER_MM[0])) {
      return { soort: "pictogram" };
    }
    return null;
  }

  function verplaats(greep, p) {
    var breedte = mmx(STICKER_MM[0]), hoogte = mmx(STICKER_MM[1]);
    if (greep.soort === "pictogram") {
      var y = (p.y - greep.grijpY) / hoogte * STICKER_MM[1];
      state.pictogramY = klem(y / SPELING_MM, 0, 1);
      var schuif = document.getElementById("pv-pictogram-schuif");
      if (schuif) { schuif.value = String(Math.round(state.pictogramY * 100)); }
      merkPositieKnoppen();
      return;
    }
    var doel = greep.soort === "logo" ? state.logo : state.teksten[greep.index];
    var vak = greep.soort === "logo" ? logoRechthoek()
                                     : tekstRechthoek(state.teksten[greep.index]);
    // binnen de sticker houden: wat eroverheen steekt wordt bij het drukken
    // toch weggeknipt, dus laten we het de klant hier al zien
    var halfB = vak ? (vak.b / 2) / breedte : 0;
    var halfH = vak ? (vak.h / 2) / hoogte : 0;
    doel.x = klem((p.x - greep.grijpX) / breedte,
                  Math.min(0.5, halfB), Math.max(0.5, 1 - halfB));
    doel.y = klem((p.y - greep.grijpY) / hoogte,
                  Math.min(0.5, halfH), Math.max(0.5, 1 - halfH));
  }

  canvas.addEventListener("pointerdown", function (evt) {
    var p = punt(evt);
    var greep = pakOp(p);
    if (!greep) { return; }
    var breedte = mmx(STICKER_MM[0]), hoogte = mmx(STICKER_MM[1]);
    if (greep.soort === "pictogram") {
      greep.grijpY = p.y - state.pictogramY * SPELING_MM / STICKER_MM[1] * hoogte;
    } else {
      var doel = greep.soort === "logo" ? state.logo : state.teksten[greep.index];
      greep.grijpX = p.x - doel.x * breedte;
      greep.grijpY = p.y - doel.y * hoogte;
    }
    sleep = greep;
    canvas.setPointerCapture(evt.pointerId);
    canvas.classList.add("is-slepend");
    evt.preventDefault();
  });

  canvas.addEventListener("pointermove", function (evt) {
    if (!sleep) {
      canvas.style.cursor = pakOp(punt(evt)) ? "grab" : "default";
      return;
    }
    verplaats(sleep, punt(evt));
    teken();
  });

  function laatLos(evt) {
    if (!sleep) { return; }
    sleep = null;
    canvas.classList.remove("is-slepend");
    if (evt && evt.pointerId !== undefined && canvas.hasPointerCapture(evt.pointerId)) {
      canvas.releasePointerCapture(evt.pointerId);
    }
  }
  canvas.addEventListener("pointerup", laatLos);
  canvas.addEventListener("pointercancel", laatLos);

  /* ---------- bediening in het paneel ---------- */

  function koppel(id, gebeurtenis, doe) {
    var el = document.getElementById(id);
    if (el) { el.addEventListener(gebeurtenis, function () { doe(el); teken(); }); }
    return el;
  }

  state.teksten.forEach(function (tekst, i) {
    koppel("pv-tekst-" + (i + 1), "input", function (el) {
      tekst.tekst = el.value;
      bijwerkenTekstmeldingen();
      bijwerkenKnop();
    });
    koppel("pv-tekst-" + (i + 1) + "-schaal", "input", function (el) {
      tekst.schaal = TEKST.schaal_min +
        (TEKST.schaal_max - TEKST.schaal_min) * (Number(el.value) / 100);
      bijwerkenTekstmeldingen();
    });
    koppel("pv-tekst-" + (i + 1) + "-kleur", "input", function (el) {
      tekst.kleur = el.value;
    });
  });

  koppel("pv-pictogram-schuif", "input", function (el) {
    state.pictogramY = Number(el.value) / 100;
    merkPositieKnoppen();
  });

  var positieKnoppen = document.querySelectorAll("[data-pictogram-positie]");
  function merkPositieKnoppen() {
    positieKnoppen.forEach(function (k) {
      var waarde = Number(k.getAttribute("data-pictogram-positie"));
      k.classList.toggle("is-actief", Math.abs(state.pictogramY - waarde) < 0.02);
    });
  }
  positieKnoppen.forEach(function (knop) {
    knop.addEventListener("click", function () {
      state.pictogramY = Number(knop.getAttribute("data-pictogram-positie"));
      var schuif = document.getElementById("pv-pictogram-schuif");
      if (schuif) { schuif.value = String(Math.round(state.pictogramY * 100)); }
      merkPositieKnoppen();
      teken();
    });
  });

  var pictogramKnoppen = document.querySelectorAll("[data-pictogram]");
  function merkPictogramKnoppen() {
    pictogramKnoppen.forEach(function (k) {
      k.classList.toggle("is-actief",
                         k.getAttribute("data-pictogram") === state.pictogram);
    });
  }
  pictogramKnoppen.forEach(function (knop) {
    knop.addEventListener("click", function () {
      var sleutel = knop.getAttribute("data-pictogram");
      if (!GEO.pictogrammen[sleutel]) { return; }
      state.pictogram = sleutel;
      merkPictogramKnoppen();
      pictogramBeeld(sleutel, function () { teken(); });
      teken();
    });
  });

  koppel("pv-logo-schaal", "input", function (el) {
    state.logo.breedte = GEO.logo.breedte_min +
      (GEO.logo.breedte_max - GEO.logo.breedte_min) * (Number(el.value) / 100);
  });

  /* ---------- logo uploaden ---------- */

  function toonLogoStatus(tekst, isFout) {
    var el = document.getElementById("pv-logo-status");
    if (!el) { return; }
    el.textContent = tekst || "";
    el.classList.toggle("is-fout", !!isFout);
  }

  function toonFout(tekst) {
    var el = document.getElementById("pv-foutmelding");
    if (!el) { return; }
    el.textContent = tekst || "";
    el.hidden = !tekst;
  }

  function kiesLogo(bestand) {
    if (!bestand) { return; }
    if (bestand.size > 8 * 1024 * 1024) {
      toonLogoStatus("Dit bestand is groter dan 8 MB.", true);
      return;
    }
    toonLogoStatus("Bezig met uploaden...");
    state.bezig = true;
    bijwerkenKnop();

    var lezer = new FileReader();
    lezer.onload = function () {
      laadBeeld(lezer.result, function (img) {
        if (img) { state.logoBeeld = img; teken(); }
      });
    };
    lezer.readAsDataURL(bestand);

    var fd = new FormData();
    fd.append("bestand", bestand);
    fetch(ASSETS.uploadUrl, { method: "POST", body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        state.bezig = false;
        if (!res.ok || !res.j.url) {
          toonLogoStatus(res.j.fout || "Uploaden is niet gelukt.", true);
          state.logoUrl = "";
        } else {
          state.logoUrl = res.j.url;
          toonLogoStatus("Logo geplaatst. Sleep het in het voorbeeld op zijn plek.");
        }
        bijwerkenKnop();
      })
      .catch(function () {
        state.bezig = false;
        state.logoUrl = "";
        toonLogoStatus("Uploaden is niet gelukt. Probeer het nog eens.", true);
        bijwerkenKnop();
      });
  }

  var logoInvoer = document.getElementById("pv-logo-invoer");
  if (logoInvoer) {
    logoInvoer.addEventListener("change", function () { kiesLogo(logoInvoer.files[0]); });
  }
  var dropzone = document.getElementById("pv-dropzone");
  if (dropzone) {
    ["dragenter", "dragover"].forEach(function (naam) {
      dropzone.addEventListener(naam, function (e) {
        e.preventDefault(); dropzone.classList.add("is-actief");
      });
    });
    ["dragleave", "drop"].forEach(function (naam) {
      dropzone.addEventListener(naam, function (e) {
        e.preventDefault(); dropzone.classList.remove("is-actief");
      });
    });
    dropzone.addEventListener("drop", function (e) {
      if (e.dataTransfer && e.dataTransfer.files.length) {
        kiesLogo(e.dataTransfer.files[0]);
      }
    });
  }

  var logoWeg = document.getElementById("pv-logo-weg");
  if (logoWeg) {
    logoWeg.addEventListener("click", function () {
      state.logoUrl = ""; state.logoBeeld = null;
      if (logoInvoer) { logoInvoer.value = ""; }
      toonLogoStatus("");
      teken();
    });
  }

  /* ---------- aantal en winkelwagen ---------- */

  function euro(centen) {
    return "€ " + (centen / 100).toFixed(2).replace(".", ",");
  }

  function vulAantallen() {
    var keuze = document.getElementById("pv-aantal");
    if (!keuze || !VARIANTEN.length) { return; }
    VARIANTEN.forEach(function (v) {
      var optie = document.createElement("option");
      optie.value = String(v.id);
      var stuks = parseInt(v.titel, 10);
      optie.textContent = v.titel + " - " + euro(v.prijs) +
        (stuks ? " (" + euro(v.prijs / stuks) + " per sticker)" : "");
      keuze.appendChild(optie);
    });
    keuze.value = String(state.variantId);
    keuze.addEventListener("change", function () {
      state.variantId = Number(keuze.value);
      toonPrijs();
    });
    toonPrijs();
  }

  function toonPrijs() {
    var el = document.getElementById("pv-prijs");
    var variant = VARIANTEN.filter(function (v) { return v.id === state.variantId; })[0];
    if (el && variant) { el.textContent = euro(variant.prijs); }
  }

  function bijwerkenKnop() {
    var knop = document.getElementById("pv-toevoegen");
    if (!knop) { return; }
    knop.disabled = state.bezig;
    knop.textContent = state.bezig ? "Even geduld..." : "In winkelwagen";
  }

  function positieVoorProperty(el) {
    return { x: Number(el.x.toFixed(4)), y: Number(el.y.toFixed(4)) };
  }

  function tekstOpmaak(tekst) {
    return JSON.stringify({
      x: Number(tekst.x.toFixed(4)),
      y: Number(tekst.y.toFixed(4)),
      schaal: Number(tekst.schaal.toFixed(3)),
      kleur: tekst.kleur
    });
  }

  function positieNaam() {
    if (state.pictogramY <= 0.02) { return "boven"; }
    if (state.pictogramY >= 0.98) { return "onder"; }
    return "midden (" + Math.round(state.pictogramY * SPELING_MM * 10) / 10 + " mm van boven)";
  }

  function snapshotBlob(klaar) {
    var kopie = document.createElement("canvas");
    kopie.width = LOGISCH_B * DPR;
    kopie.height = LOGISCH_H * DPR;
    var t = kopie.getContext("2d");
    t.setTransform(DPR, 0, 0, DPR, 0, 0);
    t.fillStyle = "#ffffff";
    t.fillRect(0, 0, LOGISCH_B, LOGISCH_H);
    var echt = ctx;
    ctx = t;                       // measureText moet op dezelfde context
    tekenOp(t, MARGE_MM);
    ctx = echt;
    kopie.toBlob(function (blob) { klaar(blob); }, "image/png");
  }

  function voegToe() {
    toonFout("");
    if (!state.variantId) { toonFout("Kies eerst een aantal."); return; }
    state.bezig = true;
    bijwerkenKnop();

    snapshotBlob(function (blob) {
      var klaarZetten = function () {
        var fd = new FormData();
        fd.append("id", String(state.variantId));
        fd.append("quantity", "1");
        fd.append("properties[Plaatje]", GEO.pictogrammen[state.pictogram].naam);
        fd.append("properties[Plaatje staat]", positieNaam());
        state.teksten.forEach(function (tekst, i) {
          fd.append("properties[Tekst " + (i + 1) + "]", (tekst.tekst || "").trim());
          fd.append("properties[_Tekst" + (i + 1) + "Opmaak]", tekstOpmaak(tekst));
        });
        fd.append("properties[_Pictogram]", state.pictogram);
        fd.append("properties[_PictogramY]", String(state.pictogramY.toFixed(4)));
        fd.append("properties[_LogoURL]", state.logoUrl || "");
        fd.append("properties[_LogoPositie]",
                  state.logoUrl ? JSON.stringify(positieVoorProperty(state.logo)) : "");
        fd.append("properties[_LogoSchaal]",
                  state.logoUrl ? String(state.logo.breedte.toFixed(4)) : "");
        fd.append("properties[_SnapshotURL]", state.snapshotUrl || "");

        fetch("/cart/add.js", { method: "POST", body: fd })
          .then(function (r) {
            if (!r.ok) { throw new Error("winkelwagen"); }
            window.location.href = "/cart";
          })
          .catch(function () {
            state.bezig = false;
            bijwerkenKnop();
            toonFout("Toevoegen aan de winkelwagen lukte niet. Probeer het nog eens.");
          });
      };

      if (!blob || !ASSETS.uploadUrl) { klaarZetten(); return; }
      var fd = new FormData();
      fd.append("bestand", blob, "voorbeeld.png");
      fetch(ASSETS.uploadUrl, { method: "POST", body: fd })
        .then(function (r) { return r.json(); })
        .then(function (j) { state.snapshotUrl = j.url || ""; })
        .catch(function () { state.snapshotUrl = ""; })
        .then(klaarZetten);
    });
  }

  var knop = document.getElementById("pv-toevoegen");
  if (knop) { knop.addEventListener("click", voegToe); }

  /* ---------- opstarten ---------- */

  function hiDPI() {
    // Alleen de scherpte: meer echte pixels, zelfde logische tekenruimte. De
    // CSS bepaalt hoe groot het canvas op het scherm staat, dus hier geen
    // inline breedte zetten (dat brak het meeschalen met de kolom).
    DPR = window.devicePixelRatio || 1;
    canvas.width = LOGISCH_B * DPR;
    canvas.height = LOGISCH_H * DPR;
    ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
  }

  window.__pvstudio = { state: state, teken: teken, geo: GEO };

  hiDPI();
  vulAantallen();
  bijwerkenKnop();
  merkPictogramKnoppen();
  merkPositieKnoppen();
  bijwerkenTekstmeldingen();
  pictogramBeeld(state.pictogram, function () { teken(); });
  teken();
})();
